import { createTypes, actionCreator } from 'redux-action-creator';
import { parseJSON, handleNetworkError, getCookie } from '../../utils'


export const signingRecordTypes = createTypes(['REQUEST', 'RECEIVE', 'ERROR', 'SUCCESS'], 'SIGNING_RECORDS');
export const additionalAxDocumentTypes = createTypes(['REQUEST', 'RECEIVE', 'ERROR', 'SUCCESS'], 'AX_DOCUMENT');


export const requestElectronicSigningRecords = () => {
    return {
        type: signingRecordTypes.REQUEST,
    };
};

export const receiveElectronicSigningRecords = (response) => {
    return {
        type: signingRecordTypes.RECEIVE,
        data: response,
    };
};

export const receiveElectronicSigningRecordsError = (response) => {
    return {
        type: signingRecordTypes.ERROR,
        error: response,
    };
};

export const fetchElectronicSigningRecords = (customerId) => {
    return dispatch => {
        let apiUrl = `/api/v1/electronicsignings/${customerId}/`

        dispatch(requestElectronicSigningRecords());

        let headers = {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
        }

        return fetch(apiUrl, {
            headers: headers,
            credentials: 'include',
        })
        .then(parseJSON)
        .then(response => {
            try {
                dispatch(receiveElectronicSigningRecords(response));
            } catch (e) {
                dispatch(receiveElectronicSigningRecordsError(response));
            }
        })
        .catch(handleNetworkError);
    };
};



export const requestAdditionalDocument = () => {
    return {
        type: additionalAxDocumentTypes.REQUEST,
    };
};

export const receiveAxAdditionalDocument = (response) => {
    return {
        type: additionalAxDocumentTypes.RECEIVE,
        data: response
    };
};

export const receiveAxAdditionalDocumentError = (response) => {
    return {
        type: additionalAxDocumentTypes.ERROR,
        data: response
    };
};

export const createAxAdditionalDocument = (data) => {
  return dispatch => {
      const apiUrl = `/api/v1/contract/ax_extra_documents/`

      dispatch(requestAdditionalDocument());

      let headers = {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'X-CSRFToken': getCookie("csrftoken"),
      }

      return fetch(apiUrl, {
          headers: headers,
          method: 'POST',
          body: JSON.stringify(data),
          credentials: 'include',
      })
      .then(parseJSON)
      .then(response => {
          if (response.status !== "error") {
              dispatch(receiveAxAdditionalDocument(response));    
          } else {
              dispatch(receiveAxAdditionalDocumentError(response))
          }
          return response
      })
      .catch(() => dispatch(receiveAxAdditionalDocumentError({status:'error', errorMessage:'Óvænt netvilla. Vinsamlegast prufaðu að endurhlaða síðuna og reyna aftur eða hafðu samband við Allianz.'})));
  };
};
